import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { translate } from 'react-i18next';
import FlatButton from 'material-ui/FlatButton';
import swal from 'sweetalert';
import { startSessionUserGeneric } from '../libs/services';
//import TextField from 'material-ui/TextField';

var Config = require('../config');

class ModalAccessGeneric extends Component{
	constructor(props, context) {
		super(props, context);
		this.startSession = this.startSession.bind(this);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.state = {
		    show: false,
		    user_name:""
		};
	}

	componentDidMount() {
		this.props.onRef(this);
	}
	componentWillUnmount() {
		this.props.onRef(null)
	}

	handleClose() {
		this.props.cancel();
		this.setState({ show: false, user_name:""});
	}

	handleShow() {
		this.setState({ show: true});
	}

	async startSession(){
		if(this.isValidForm()){
			var obj = {};
			obj.access_name = this.state.user_name;

			var response = await startSessionUserGeneric(obj);

			if(response !== undefined){
				this.setState({ show: false});
				this.props.save(response.id);
			}else{
				swal('Error', 'Error al iniciar sesión','error');
			}

		}else{
			swal('¡Error!', 'Es necesario agregar su nombre', 'error');
		}
		
	}

	//Evento de cambio en elementos formulario
	handleChange = (event, index, value) => {
	    this.setState({
	      [event.target.name]: event.target.value
	    });

	    if(event.target.required){
	    	if (event.target.value.length > 0) {
	    		this.setState({['errorText_'+event.target.name]: ""})
	    	} else{
	    		this.setState({['errorText_'+event.target.name]: "Campo obligatorio"})
	    	};
	    }  
	}

	//Verificar si el formulario es valido
	isValidForm() {
	    const inputs = document.querySelectorAll('input');
	    let isFormValid = true;
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showInputError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });	  
	    
	    return isFormValid;
	}

	//Desplegar error en campos requeridos
	showInputError(refName) {
		const control = document.getElementById(refName);
		
		if(control.value === ""){
			if(control !== null){
	            control.classList.add('error');
	        }
			return false;
		}else{
			if(control.className.includes('error')){
				control.classList.remove('error');
			}
			return true;
		}

		/*
	    const validity = this.refs[refName].state;
	    
	    if (!validity.hasValue) {//console.log('vacio')
	    	this.setState({['errorText_'+refName]: "Campo obligatorio"})
	      	return false;
	    }else {//console.log('valor')
	    	this.setState({['errorText_'+refName]: ""})
	    }
	    return true;
	    */
	}

	render(){
		const { t } = this.props;
		return(
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>{t('content.modal_access_generic.MAIN')}</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{textAlign:"center"}}>
		        		<div className="col-xs-12 col-sm-8 col-md-offset-2">
			        		<span className="span-min">
			        			{t('content.modal_access_generic.name')}
			        		</span>
				        	<input
				        		className="col-xs-12 form-control"
				        		ref="user_name"
				        		fullWidth={true}
				        		//errorText={this.state.errorText_user_name}
				        		name="user_name"
				        		id="user_name"
				        		value={this.state.user_name}
				        		onChange={this.handleChange}
				        		required
				        		autoFocus
				        	/>
			        	</div>
			        	{/*
		 				 <TextField 
		 				 style={{width:'300px'}}
		 				 	ref="user_name"
		 				 	fullWidth={true} 
		 				 	errorText= {this.state.errorText_user_name}  
			            	name="user_name" 
			            	value={ this.state.user_name } 
			            	onChange={ this.handleChange } 
			            	floatingLabelText={t('content.modal_access_generic.name')} floatingLabelFixed={true} required/>
					 	*/}
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.login')}  onClick={this.startSession}/>
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalAccessGeneric) 